import React from 'react';
import { injectIntl } from 'react-intl-next';
import EmptyState from '@atlaskit/empty-state';
import messages from './messages';
import notConnectedEmptyStateIcon from '../../icons/plug.svg';
import mountTrackerFactory from '../../../../common/analytics/mount-tracker-factory';
import { type WrappedComponentProps } from 'react-intl-next';

const MountTracker = mountTrackerFactory('connectSpaceNoPermissionEmptyState');

const NoPermission = ({ intl: { formatMessage } }: WrappedComponentProps) => (
	<>
		<EmptyState
			size="wide"
			imageUrl={notConnectedEmptyStateIcon}
			maxImageWidth={201}
			header={formatMessage(messages.heading)}
			description={formatMessage(messages.description)}
		/>
		<MountTracker />
	</>
);

export default injectIntl(NoPermission);
